import { StatusIndicator, Text } from "@nike/eds";
import { ProcessStep, ProcessStepStatus } from "../../graphql/graphql";
import { formatDateTime } from "../../shared/Utils";

interface ConsignmentWorkflowProps {
  steps: ProcessStep[];
}

// Allowed StatusIndicator status values: "success" | "warning" | "danger" | "neutral" | "inactive"
function mapProcessStepStatusToIndicator(status: ProcessStepStatus): "success" | "warning" | "danger" | "neutral" | "inactive" {
  switch (status) {
    case ProcessStepStatus.Completed:
      return "success";
    case ProcessStepStatus.Open:
      return "neutral";
    case ProcessStepStatus.Pending:
      return "inactive";
    default:
      return "neutral";
  }
}

function ObjectKeyValueList( obj: Record<string, string> ) {
  return (
    <ul className="eds-list eds-list--bare eds-spacing--ml-28">
      {Object.entries(obj).map(([key, value]) => (
        <li key={key}>
          <Text font="body-3" as="span">{key}:</Text> <Text font="body-3" as="span">({value})</Text>
        </li>
      ))}
    </ul>
  );
}

function StepContextBadge( step: ProcessStep ) {
  if (step.status === ProcessStepStatus.Pending && step.context && step.context.badge) {
    return `(${step.context.badge})`;
  }
  return null;
}

export const ConsignmentWorkflow = ({ steps }: ConsignmentWorkflowProps) => {
  return (
    <div className="eds-flex eds-flex--direction-column eds-gap--16 eds-overflow--auto">
      {steps.map((step, index) => {
        let status: ProcessStepStatus;

        if (step.completedTimestamp) {
          status = ProcessStepStatus.Completed;
        } else if (index === 0 || steps[index - 1].completedTimestamp) {
          status = ProcessStepStatus.Open;
        } else {
          status = ProcessStepStatus.Pending;
        }

        const stepTitle = `${step.title} ${StepContextBadge(step) || ''}`.trim();
        return (
          <div key={step.title} className="eds-flex eds-flex--direction-column eds-items--center eds-gap--8">
            <StatusIndicator
              label={stepTitle}
              size="x-large"
              status={mapProcessStepStatusToIndicator(status)}
            />
            {step.title && <Text className={'eds-spacing--ml-28'} font={'body-3'} >{formatDateTime(step.completedTimestamp, true)}</Text>}
            {StepContextBadge(step) && (() => {
              let parsed: Record<string, string> = {};
              try {
                parsed = step.context!.context ? JSON.parse(step.context!.context) : {};
              } catch (e) {
                // Optionally log or handle error
                console.log('Error parsing step context JSON:', e);
                parsed = {};
              }
              return ObjectKeyValueList(parsed);
            })()}
          </div>
        );
      })}
    </div>
  );
};